import * as React from "react";
import { cloneDeep, set } from "lodash";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

import FlowFormBase from "../../Base/FlowForm/FlowFormBase";
import chapterDefs from "./chapterDefs";
import descriptions from "./Descriptions";
import chapters from "./Chapters";
import {
  useKeyForm,
  constants,
  create,
  update,
  destroyPostForm,
  destroyPatchForm,
  detailUrl,
  useKey,
} from "../../../../store/key";
import FullPageSpinner from "../../../Loaders/FullPageSpinner";
import { setActiveFormInstance, updateActiveFormInstance } from "../../../../store/base";
import { useUser } from "../../../../store/users";
import { useKeyPermission } from "../../../../store/keypermission";

export default function KeyForm({ method = "POST", id, userId, permissionId }) {
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;
  const [loading, setLoading] = React.useState(false);
  const formLoaded = Boolean(useKeyForm(method, id));
  const { replace } = useHistory();

  const [instance, instanceLoading] = useKey(id);
  const [hasSetInstance, setHasSetInstance] = React.useState(false);

  const [defaultUser, defaultUserLoading] = useUser(userId);
  const [defaultPermission, defaultPermissionLoading] = useKeyPermission(permissionId);
  const [hasSetDefaults, setHasSetDefaults] = React.useState(false);

  React.useEffect(() => {
    if (!hasSetInstance && instance != null) {
      dispatch(setActiveFormInstance({
        storeName: storeName,
        data: instance
      }));

      setHasSetInstance(true);
    }
  }, [hasSetInstance, instance])

  React.useEffect(() => {
    if (id != null) { return; }
    if (!hasSetDefaults && (!!defaultUser || !!defaultPermission) && (userId == null || !!defaultUser) && (permissionId == null || !!defaultPermission)) {
      const obj = {"permission":defaultPermission, "user":defaultUser, "key_name":defaultPermission?.str_representation};
      dispatch(updateActiveFormInstance({
        storeName: storeName,
        data: obj
      }));

      setHasSetDefaults(true);
    }

  }, [defaultUser, defaultPermission, hasSetDefaults])

  const onSuccess = (_, returned) => {
    setLoading(false);
    checkout(true);
    replace(detailUrl({ id: returned.id }));
  };

  React.useEffect(() => {
    return () => {
      if (method === "PATCH") {
        dispatch(destroyPatchForm(false));
      } else {
        dispatch(destroyPostForm(false));
      }
    };
  }, []);

  const onError = () => {
    setLoading(false);
  };

  const checkout = (success) => {
    if (method === "PATCH") {
      dispatch(destroyPatchForm(success));
    } else {
      dispatch(destroyPostForm(success));
    }
  };

  const onSubmit = () => {
    setLoading(true);

    if (method === "PATCH") {
      dispatch(
        update({
          successCallback: onSuccess,
          errorCallback: onError,
          id,
        })
      );
    } else {
      dispatch(
        create({
          successCallback: onSuccess,
          errorCallback: onError,
        })
      );
    }
  };

  return (
    <>
      {(loading || !formLoaded) && <FullPageSpinner />}

      <FlowFormBase
        {...{
          storeName,
          chapterDefs: chapterDefs(),
          chapters,

          descriptions,
          method,
          onSubmit,

          title:
            method === "POST" ? "Lägg till nyckel" : "Uppdatera nyckel",
        }}
      />
    </>
  );
}
